export default "__VITE_ASSET__DAKhZGac__"